import type { UseMapManifestResult } from '@garner-health/components-map-v3';
import { useMapManifest } from '@garner-health/components-map-v3';
import constants from 'app-constants';

export function useMapAssets(): UseMapManifestResult {
  return useMapManifest(constants.map.manifestUrl, {
    tileUrl: constants.map.fallbackTileUrl,
    spriteBaseUrl: constants.map.fallbackSpriteBaseUrl,
  });
}
